const filtersReducerDefaultState = {
    showNoSamil: false,
    showInverters: false,
    showGrouped: false,
    showPeriod: 'yesterday'
};

export default (state = filtersReducerDefaultState, action) => {
    switch (action.type) {
        case 'SHOW_NO_SAMIL':
            return {
                ...state,
                showNoSamil: action.showNoSamil
            };
        case 'SHOW_INVERTERS':
            return {
                ...state,
                showInverters: action.showInverters
            };
        case 'SHOW_GROUPED':
            return {
                ...state,
                showGrouped: action.showGrouped
            };
        case 'SHOW_PERIOD':
            return {
                ...state,
                showPeriod: action.showPeriod
            };
        case 'CLEAR':
            return {
                ...state,
                showNoSamil: action.defaultFilter.showNoSamil,
                showInverters: action.defaultFilter.showInverters,
                showGrouped: action.defaultFilter.showGrouped,
                showPeriod: action.defaultFilter.showPeriod
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/filters.js